import { gql } from '@apollo/client';

export const FIND_PATIENT_BY_INS = gql`
  query FindPatientByIns($insValue: String!, $insType: InsType!) {
    insi {
      findPatientByIns(insValue: $insValue, insType: $insType) {
        id
        displayName
        dateOfBirth
      }
    }
  }
`;
